<script setup>
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    default: 'small',
    validator(value) {
      return ['large', 'medium', 'small'].includes(value)
    },
  },
})
</script>

<template>
  <div
    :class="{
      'scale-4 scale-4--serif': props.size === 'large',
      'scale-3 scale-3--serif': props.size === 'medium',
      'scale-2 scale-2--serif': props.size === 'small',
    }"
  >
    <span class="quotation-content">
      {{ props.text }}
    </span>
  </div>
</template>

<style lang="scss">
.quotation-content {
  &:before {
    content: '«';
  }
  &:after {
    content: '»';
  }
}
</style>
